"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.square = square;
var color_1 = require("../../color");
/**
 * Generates a square color harmony.
 * @param {Color} color - The base color.
 * @returns {[Color, Color, Color, Color]} An array containing the base color and three square harmony colors.
 */
function square(color) {
    var hsl = color.toHsl();
    var color1 = __assign(__assign({}, hsl), { h: (hsl.h + 90) % 360 });
    var color2 = __assign(__assign({}, hsl), { h: (hsl.h + 180) % 360 });
    var color3 = __assign(__assign({}, hsl), { h: (hsl.h + 270) % 360 });
    return [color, new color_1.Color(color1), new color_1.Color(color2), new color_1.Color(color3)];
}
